<div class="auth-page-wrapper public-page">
	<div class="login-wave-header"></div>

  <div class="form-page-wrapper text-center">
    <h1 class="fw-bold" style="font-size: 64px; color: #3a7669;">404</h1>
    <h2 class="fs-5 fw-bold my-3">Pagina non trovata</h2>
    <p class="text-muted-kf">La pagina che stai cercando non esiste o è stata spostata.</p>
    
    <div class="mt-5">
      <a href="/" class="btn-kf-primary text-decoration-none d-inline-block">TORNA ALLA HOME</a>
    </div>
  </div>

  <div class="login-wave-footer"></div>
</div>
